import { WQI_PARAMS } from "./wqiParams";

/**
 * Map WQI param keys → actual station response keys
 * (THIS FIXES YOUR MAIN BUG)
 */
const KEY_MAP = {
  dissolved_oxygen_mg_l_clean_avg: "dissolved_oxygen_mg_l_avg",
  ph_clean_avg: "ph_avg",
  bod_mg_l_clean_avg: "bod_mg_l_avg",
  cod_mg_l_clean_avg: "cod_mg_l_avg",
  ammonia_mg_l_clean_avg: "ammonia_mg_l_avg",
  chloride_mg_l_clean_avg: "chloride_mg_l_avg",
  tss_mg_l_clean_avg: "tss_mg_l_avg",
};

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : NaN;
};

const clamp = (v, min = 0, max = 100) =>
  Math.max(min, Math.min(max, v));

/* ---------------- Qi formulas ---------------- */

const qiNormal = (Vi, Si) => (Vi / Si) * 100;

// Dissolved Oxygen (deficit from ideal)
const qiDO = (Vi, Si) => {
  const idealDO = 14.6;
  if (Vi <= 0 || Vi >= idealDO) return 100;
  return ((idealDO - Vi) / (idealDO - Si)) * 100;
};

// pH deviation from neutral
const qiPH = (Vi) => {
  if (Vi >= 7) return ((Vi - 7) / (8.5 - 7)) * 100;
  return ((7 - Vi) / (7 - 6.5)) * 100;
};

/* ---------------- Subindex selector ---------------- */
/*
const subindexEPA = (param, Vi) => {
  if (!Number.isFinite(Vi)) return null;

  if (param.type === "DO") return clamp(qiDO(Vi, param.Si));
  if (param.type === "PH") return clamp(qiPH(Vi));

  return clamp(qiNormal(Vi, param.Si));
};*/

const subindexEPA = (param, Vi) => {
  if (!Number.isFinite(Vi)) return null;

  if (param.type === "DO") return qiDO(Vi, param.Si);
  if (param.type === "PH") return qiPH(Vi);

  return qiNormal(Vi, param.Si);
};

/* ===================================================
   EPA WEIGHTED ARITHMETIC WQI (FINAL)
   =================================================== */
export function computeWqiEPA(stations, debug = false) {
  if (!stations || stations.length === 0) return null;

  let weightedSum = 0;
  let weightSum = 0;

  for (const param of WQI_PARAMS) {
    const field = KEY_MAP[param.key];
    if (!field) continue;

    const values = stations
      .map(s => toNum(s[field]))
      .filter(v => Number.isFinite(v) && v > 0); // exclude zero values

    if (!values.length) continue;

    const Vi = values.reduce((a, b) => a + b, 0) / values.length;
    const Qi = subindexEPA(param, Vi);

    if (!Number.isFinite(Qi)) continue;

    weightedSum += Qi * param.Wi;
    weightSum += param.Wi;

    // ✅ SAFE debug per-parameter
    if (debug) {
      console.table([{
        station: stations[0]?.site_name,
        parameter: param.key,
        Vi: Vi.toFixed(3),
        Qi: Qi.toFixed(2),
        Wi: param.Wi,
        weighted: (Qi * param.Wi).toFixed(2),
      }]);
    }
  }

  if (weightSum === 0) return null;

  return Math.round(weightedSum / weightSum);
}